import type { Severity } from "@/lib/api";

const STYLES: Record<Severity, { label: string; className: string }> = {
  BLOCKER: {
    label: "Blocker",
    className: "bg-curate-danger/10 text-curate-danger border-curate-danger/30",
  },
  WARN: {
    label: "Warn",
    className: "bg-curate-warn/10 text-curate-warn border-curate-warn/30",
  },
  INFO: {
    label: "Info",
    className: "bg-curate-mist text-curate-ink border-curate-slate/25",
  },
};

export function SeverityBadge({ level }: { level: Severity }) {
  const s = STYLES[level];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-2xs font-medium ${s.className}`}
    >
      {s.label}
    </span>
  );
}
